import React,{useEffect,useState} from 'react';
import {RespBkMthdMapp} from '../function_lib/common_lib';
import {Education_Level} from '../json_data';

import './comp_member_filters.css';
import { use } from 'react';
export const Comp_Member_Filters_Horizon=(props)=>{
    
    useEffect(()=>{
       
       
    },[])
    useEffect(()=>{
        if(props.pGautraList.length>0){
            RespBkMthdMapp(this,"hevent_flt_rightbar",function(data){
                // alert(JSON.stringify(data));
                props.onRunSearch(data);
            })
        }
        
    },[props.pGautraList,props.pStateList]);

    let _educationLevel=Education_Level;
    return(<>
    
 {/* <!--end mobile view filter button --> as of now place below code to applier compoent */}

    <aside class="col-lg-3 filter_bar" id="sidebar_fixed">
    <a href="javascript:void(0)" class="open_filters"><div class="layer"></div></a>
    {/* <!-- Mobile menu overlay mask --> */}
    {/* <div class="filter_col">
    
    </div> */}
    <div class="filter_col">
        <div class="inner_bt"><a href="#" class="open_filters"><i class="fa fa-times" aria-hidden="true"></i></a></div>
        <a class="reset_filters" onClick={()=>window.location.reload()} href="javascript:void(0)"><span class="badges"><span class="new">Reset Filters</span></span></a>
        <div class="filter_type version_2">
            <h4><a href="#filter_12" data-toggle="collapse" class="opened">Request ID/Name</a></h4>
            <div class="collapse show" id="filter_12">
                <div class="input-group mt-2 mb-2">
                    <input class="hcls_flt_member_id form-control" type="text" placeholder="Request ID/Name" />
                    <div class="input-group-append">
                
                    <button class="hevent_flt_rightbar" type="button"><i class="fa fa-2x fa-search-plus" aria-hidden="true"></i></button>
                    </div>
                    
                </div>
            </div>
        </div>

        {/* <div class="filter_type version_2">
            <h4><a href="#filter_6" data-toggle="collapse" class="opened">City</a></h4>
            <div class="collapse show" id="filter_6">
                <div class="input-group mt-2 mb-2">
                    <input class="hcls_flt_city form-control" type="text" placeholder="Search City" />
                    <div class="input-group-append">
                
                    <button class="hevent_flt_rightbar" type="button"><i class="fa fa-2x fa-search-plus" aria-hidden="true"></i></button>
                    </div>
                    
                </div>
            </div>
        </div> */}
{/* filter State */}

  {/* <!-- /filter_type --> */}
         <div class="filter_type version_2">
            <h4><a href="#filter_6" data-toggle="collapse" class="opened">Process Status</a></h4>
            <div class="collapse show" id="filter_6">
                <ul>
                    <li>
                        <select class="form-control hevent_flt_rightbarnn hcls_flt_procStatus">
                            <option value="0">All</option>
                            <option value="Completed">Completed</option>
                            <option value="Under Process">Under Process</option>
                            <option value="Under Review">Under Review</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Cancelled">Cancelled</option>
                        </select>
                    </li>
                    
                </ul>
            </div>
        </div>
       
        {/* <!-- /filter_type --> */}


{/* <div class="filter_type version_2">
            <h4><a href="#filter_7" data-toggle="collapse" class="opened">By State</a></h4>
            <div class="collapse" id="filter_7">
                <ul>
                    {props.pStateList.map((item,index)=>{
                        return <li>
                        <label class="container_check">{item["name"]}<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_states" value={item["name"]}  />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    })}
                   
                </ul>
            </div>
        </div> */}
{/* filter gautra */}
        
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_7" data-toggle="collapse" class="opened">Gender</a></h4>
            <div class="collapse show" id="filter_7">
                
                <ul>
                <li>
                        <label class="container_radio">All<small></small>
                            <input type="radio" name="candi_premim_search" className="hevent_flt_rightbar hcls_flt_gender" value="0"  />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_radio">Male<small></small>
                            <input type="radio" name="candi_premim_search" className="hevent_flt_rightbar hcls_flt_gender" value="Male"  />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_radio">Female<small></small>
                            <input type="radio" name="candi_premim_search" className="hevent_flt_rightbar hcls_flt_gender" value="Female" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>    
                
            </div>
        </div> */}

        
{/* filter gautra */}
<div class="filter_type version_2">
            <h4><a href="#filter_11" data-toggle="collapse" class="opened">Select Service</a></h4>
            <div class="collapse show" id="filter_11">
                <ul>
                    {props.pGautraList.map((item,index)=>{
                        return <li>
                        <label class="container_check">{item["category_name"]}<small></small>
                            <input type="radio" defaultChecked={"true"} name="flt_category_form" className="hevent_flt_rightbar hcls_flt_category_name" value={item["id"]}  />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    })}
                   
                </ul>
            </div>
        </div>
{/* filter gautra */}
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_1" data-toggle="collapse" class="opened">Salary Per Year</a></h4>
            <div class="collapse" id="filter_1">
                <ul>
                    <li>
                        <label class="container_check">₹5 — ₹6 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="5,6"  />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹6 — ₹8 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="6,8" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹8 — ₹10 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="8,10" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹10 — ₹15 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="10,15" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹15 — ₹20 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="15,20" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹20 — ₹30 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="20,30" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                    <li>
                        <label class="container_check">₹30 — ₹40 lac<small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="30,40" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                   
                    <li>
                        <label class="container_check">₹40 lac<b>+</b>  <small></small>
                            <input type="checkbox" className="hevent_flt_rightbar hcls_flt_price" value="41,-11" />
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ul>
            </div>
        </div> */}
        {/* filter 5 */}
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_5" data-toggle="collapse" class="open">Education</a></h4>
            <div class="collapse show" id="filter_5" >
            
                <ul>
                    {typeof _educationLevel!=="undefined"?_educationLevel.map((item,index)=>{
                        return(<li>
                            <label  class="container_radio">{item.title} <small></small>
                                <input  type="radio" class="hevent_flt_rightbar hcls_flt_edu_level" name="flt_edu_level" value={item.value} />
                                <span class="checkmark"></span>
                            </label>
                        </li>)
                    })
                    :''}
                    
                </ul>
            </div>
          
        </div> */}
        {/* end of filter 5 */}
        {/* filter index  6 Mangalic */}
       
        {/* End of  Filter 6 */}
        
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_4" data-toggle="collapse" class="open">Job Shift</a></h4>
            <div class="collapse show" id="filter_4" >
                <div class="custom-search-input">
                    <input type="text" placeholder="Search" />
                    <button type="submit"><i class="fa-solid fa-magnifying-glass"></i></button>
                </div>
                <ul>
                    {typeof props.filters.job_shifts!=="undefined"?props.filters.job_shifts.map((item,index)=>{
                        return(<li>
                            <label  class="container_radio">{item.name} <small></small>
                                <input  type="radio" class="hevent_flt_rightbar hcls_flt_job_shifts" name="flt_jobshifts" value={item.id} />
                                <span class="checkmark"></span>
                            </label>
                        </li>)
                    })
                    :''}
                    
                </ul>
            </div>
            
        </div> */}
        {/* <!-- /filter_type --> */}
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_2" data-toggle="collapse" class="opened">Skin Color</a></h4>
            <div class="collapse" id="filter_2">
                <ul>
                    <li>
                        <select class="form-control hevent_flt_rightbar_nn hcls_flt_color">
                            <option value="0">Skin Color</option>
                            <option value="Fair">Fair</option>
                            <option value="Light">Light</option>
                            <option value="Medium">Medium</option>
                            <option value="Dark">Dark</option>
                        </select>
                    </li>
                    
                </ul>
            </div>
        </div> */}
       
        {/* <!-- /filter_type --> */}
        {/* <div class="filter_type version_2">
            <h4><a href="#filter_3" data-toggle="collapse" class="open">Marital Status</a></h4>
            <div class="collapse show" id="filter_3">
                <ul>
                    <li>
                <label class="container_radio">{"All"}<small></small>
                                <input type="radio" className="hevent_flt_rightbar hcls_flt_marital_status" name="hcls_flt_brand" value={0}/>
                                <span class="checkmark"></span>
                            </label>

                </li>
                <li>
                <label class="container_radio">{"Unmarried"}<small></small>
                                <input type="radio" className="hevent_flt_rightbar hcls_flt_marital_status" name="hcls_flt_brand" value={"Unmarried"}/>
                                <span class="checkmark"></span>
                            </label>

                </li>
                <li>
                <label class="container_radio">{"Divorced"}<small></small>
                                <input type="radio" className="hevent_flt_rightbar hcls_flt_marital_status" name="hcls_flt_brand" value={"Divorced"}/>
                                <span class="checkmark"></span>
                            </label>

                </li>
                <li>
                <label class="container_radio">{"Widow (विधवा)"}<small></small>
                                <input type="radio" className="hevent_flt_rightbar hcls_flt_marital_status" name="hcls_flt_brand" value={"Widow (विधवा)"}/>
                                <span class="checkmark"></span>
                            </label>

                </li>
                <li>
                <label class="container_radio">{"Widower (विधुर)"}<small></small>
                                <input type="radio" className="hevent_flt_rightbar hcls_flt_marital_status" name="hcls_flt_brand" value={"Widower (विधुर)"}/>
                                <span class="checkmark"></span>
                            </label>

                </li>
                  
                </ul>
            </div>
        </div> */}
        {/* <!-- /filter_type --> */}
        
    </div>
</aside>

</>

)

}
export default Comp_Member_Filters_Horizon